// eslint-disable-next-line import/prefer-default-export
export const CALL_ME_BACK_TYPES_GENERIC = {
  LOGIN: 'LOGIN',
  // CONTRACT: 'CONTRACT',
  // RISK: 'RISK',
  NO_POLICIES_REGISTRATION: 'NO_POLICIES_REGISTRATION',
  NO_POLICIES_DECLARATION: 'NO_POLICIES_DECLARATION',
  // GENERAL: 'GENERAL',
};
